import { mapState } from 'vuex';
import { AM_NODATA } from '../../constant';

const props = {
};

const computed = {
  ...mapState({
    user: state => state.user,
    dashboardFilters: state => state.dashboardFilters,
    activeEmployee: state => state.activeEmployee,
    singleEmpView: state => state.singleEmpView,
    employees: state => state.employeesList.data,
    totalCount: state => state.employeesList.total_count,
    loadingEmployeesList: state => state.loadingEmployeesList,
    allSelectedEmployees: state => state.selectedEmployees,
    adminUsers (state) {
      const adminUsers = state.companyAdminsList;
      return adminUsers;
    }
  }),
  noDataText () {
    return AM_NODATA;
  }
};

const methods = {
  getImgUrl (pet) {
    const images = require.context('@/assets/', false, /\.png$/);
    return images(`./${pet}.png`);
  }
};

export default {
  props,
  computed,
  methods
};
